import React from "react";
import styles from "./ViewMore.module.scss";
import ChevronLeft from "../../assets/images/chevron-left.svg";

const ViewMore = ({ values, maxDisplayed, viewAll, setViewAll }) => (
  <>
    {values.length > maxDisplayed ? (
      <div className={styles.ViewMore}>
        <div
          className={`${styles.Links}`}
          onClick={() => setViewAll(!viewAll)}
          data-testid="ViewMore"
        >
          <img
            className={`${styles.Icon} ${viewAll ? styles.Less : styles.More}`}
            src={ChevronLeft}
            alt=""
          />
          {viewAll ? "Show Less" : "Show More"}
        </div>
      </div>
    ) : null}
  </>
);

export default ViewMore;
